module.exports = __webpack_public_path__ + "img/main.e162f37f.png";